import React from "react";
import { useTranslation } from "react-i18next";
import eventImg from "../../Assets/ServiceImg/wedding.webp"; // Imagen del servicio
import eventmenubg from "../../Assets/ServiceImg/event-bg.webp"; // Imagen de fondo de las preguntas
import eventquestionsbg from "../../Assets/ServiceImg/event-qbg.webp"; // Imagen de fondo de las preguntas
import Contact from "../Home/Contact";
import ServiceInfo from "./ServiceInfo";
import Card from "react-bootstrap/Card";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import Seoimg from "../../Assets/ServiceImg/wedding.webp";

const Events = () => {
   const { t } = useTranslation();
   const location = useLocation();
   const selectedLanguage = location.pathname.startsWith("/en") ? "en" : "es";

   const seoTranslations = {
      es: {
         title: "Grabación de Eventos con Drones | Joan Company",
         description:
            "Filmación aérea de bodas, festivales y eventos corporativos. Planificación, vuelo profesional y edición cinematográfica.",
         keywords:
            "eventos con drones, grabación de eventos con drones, vídeo de eventos con drones, servicios con drones, fotografía aérea, videografía aérea",
         canonical: "https://www.joancompany.es/grabacion-eventos-dron",
      },
      en: {
         title: "Event Coverage with Drones | Joan Company",
         description:
            "Aerial filming of weddings, festivals and corporate events. Planning, professional flight and cinematic editing.",
         keywords:
            "events with drones, event recording with drones, event video with drones, drone services, aerial photography, aerial videography",
         canonical: "https://www.joancompany.es/en/grabacion-eventos-dron",
      },
   };

   return (
      <div className="service-container">
         <Helmet>
            <title key="title">{seoTranslations[selectedLanguage].title}</title>
            <meta
               key="description"
               name="description"
               content={seoTranslations[selectedLanguage].description}
            />
            <meta
               key="keywords"
               name="keywords"
               content={seoTranslations[selectedLanguage].keywords}
            />
            <link
               rel="canonical"
               href={seoTranslations[selectedLanguage].canonical}
            />
            <meta property="og:image" content={Seoimg} />
            <meta
               property="og:title"
               content={seoTranslations[selectedLanguage].title}
            />
            <meta
               property="og:description"
               content={seoTranslations[selectedLanguage].description}
            />
            <link rel="image_src" href={Seoimg} />
            <link
               rel="alternate"
               href="https://www.joancompany.es/grabacion-eventos-dron"
               hreflang="es"
            />
            <link
               rel="alternate"
               href="https://www.joancompany.es/en/grabacion-eventos-dron"
               hreflang="en"
            />
            <html lang={selectedLanguage} />
         </Helmet>
         <ServiceInfo
            title={t("event_coverage")}
            image={eventmenubg}
            subtitle={t("event_coverage_desc")}
            description={t("event_coverage_desc")}
         />
         <Card className="quote-card-view" id="service-info-card">
            <Card.Body>
               <div className="service-info-content-container">
                  <div className="service-info-content">
                     <h3>{t("event_coverage_subtitle")}</h3>
                     <div
                        dangerouslySetInnerHTML={{
                           __html: t("event_coverage_info"),
                        }}
                     />
                  </div>
                  <div className="service-info-image">
                     <img
                        src={eventImg}
                        alt={t("event_coverage")}
                        title={t("event_coverage")}
                        loading="lazy"
                     />
                  </div>
               </div>
            </Card.Body>
         </Card>
         <div
            className="service-questions"
            style={{ backgroundImage: `url(${eventquestionsbg})` }}
         >
            <div className="service-questions-container">
               <div
                  dangerouslySetInnerHTML={{
                     __html: t("event_coverage_questions"),
                  }}
               />
            </div>
         </div>
         <Contact />
      </div>
   );
};

export default Events;
